module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('accordion', [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Claimant Income Information\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid u-r-margin-bottom-0 a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-bold"
  }, [_vm._v("\n                        Was the Claimant Retired at Onset of Disease?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_but_for",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "retired_at_onset_of_disease"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedButFor),
      expression: "employedButFor"
    }],
    attrs: {
      "id": "employed_but_for"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedButFor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), (_vm.employedButFor) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }, [_vm._v("\n                        Apply Employment Contingency Discounts\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "contingency_multiplier",
      "tip-show": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Contingency discount is available when the the deceased was under the age of 67 at settlement/trial.",
      "tip-width": "200",
      "tip-name": 'contingency_multiplier_the_claimant',
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contingencyMultiplier),
      expression: "contingencyMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "contingency_multiplier",
      "required": "",
      "disabled": _vm.ageAtTrial > 67
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contingencyMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateContingency]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('contingency_multiplier')
    }
  }, [_vm._v("\n                        Apply employment contingency discounts is required\n                    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.employedButFor && _vm.ageAtTrial > 54) ? _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "p-dependency-on-income--third-label"
  }), _vm._v(" "), _c('warning-box', {
    attrs: {
      "modal-name": "warning"
    }
  }, [_c('svg', {
    staticClass: "m-icon m-icon--dark m-icon--small open",
    attrs: {
      "slot": "icon",
      "viewBox": "0 0 120 120"
    },
    slot: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#warning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-10"
  }, [_vm._v("\n                            Please note the discount figures only apply up to age 54\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "u-margin-left-40",
    attrs: {
      "slot": "b"
    },
    slot: "b"
  }, [_c('p', {
    staticClass: "c-warning-box--link"
  }, [_vm._v("Read the full description here")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.employedButFor && _vm.contingencyMultiplier) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Claimant Employed at Onset of Disease?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "employed_at_accident",
      "tip-show": true,
      "table-control": true,
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "If the claimant had stopped working at the onset of symptoms, regardless of whether they had reached state pension age, they would be classed as having been retired.",
      "tip-width": "200",
      "tip-name": "employed_at_accident"
    },
    on: {
      "change": _vm.calculateLossOfEarnings
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employedAtAccident),
      expression: "employedAtAccident"
    }],
    attrs: {
      "id": "employed_at_accident"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employedAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes — Employed")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No — Not Employed")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Claimant Level of Education\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "level_of_education"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.levelOfEducation),
      expression: "levelOfEducation"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "level_of_education",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.levelOfEducation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Degree or equivalent or higher")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GE-A"
    }
  }, [_vm._v("GCSE grades A–C up to A levels or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Below GCSE grade C or CSE grade 1 or equivalent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("No qualifications")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('level_of_education')
    }
  }, [_vm._v("\n                            Level of Education is required\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Was the Claimant Disabled?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "table-control": true,
      "for": "claimant_disabled"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabledAtAccident),
      expression: "disabledAtAccident"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "name": "claimant_disabled",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disabledAtAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateLossOfEarnings]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Not Disabled")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Disabled")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('claimant_disabled')
    }
  }, [_vm._v("\n                            Claimant Disabled is required\n                        ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showResult) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("\n                        Table A–D Discount Factor\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "tip-icon": 'formula',
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "table_a_d_discount_factor",
      "modal-name": 'income_' + _vm.uniqueId,
      "endpoint": 'contingencyMultiplier',
      "payload": _vm.contingencyMultiplierPayload,
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.theMultiplier
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.employedButFor === true) ? _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Retirement Age")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age_calc",
      "tip-icon": "info",
      "tip-side": "left",
      "tip-text": "Use government recommended retirement age/date or manually enter own",
      "tip-width": "200",
      "tip-name": "retirement_age_calc",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirementAgeCalc),
      expression: "retirementAgeCalc"
    }],
    attrs: {
      "id": "retirement_age_calc"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.retirementAgeCalc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcRetirementData]
    }
  }, [_c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Expected Retirement Age")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_age",
      "before-after": "years-old",
      "tip-icon": "formula",
      "tip-text": "Click to view calculation",
      "tip-side": "left",
      "tip-width": "140",
      "tip-name": "retirement_age",
      "modal-name": 'income_' + _vm.uniqueId,
      "payload": {
        person: this.claimant
      },
      "endpoint": 'expectedRetirementAge',
      "tip-show": _vm.retirementAgeCalc == 'auto',
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.retirementAge),
      expression: "retirementAge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "required": "",
      "disabled": _vm.retirementAgeCalc === 'auto',
      "min": _vm.earliestRetirement,
      "name": "retirement_age"
    },
    domProps: {
      "value": (_vm.retirementAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retirementAge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.retirementDateRules || !_vm.retirementAgeRules
    }
  }, [_vm._v("\n                            The Retirement Age must be greater than " + _vm._s(_vm.earliestRetirement) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-r-margin-bottom-10 u-r-margin-top-20 u-bold"
  }, [_vm._v("Expected Retirement Date")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "retirement_date",
      "table-control": true
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "retirement_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.retirementAgeCalc === 'auto'
    },
    model: {
      value: (_vm.retirementDate),
      callback: function($$v) {
        _vm.retirementDate = $$v
      },
      expression: "retirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": (!_vm.retirementDateRules || !_vm.retirementAgeRules) && _vm.employedButFor !== true
    }
  }, [_vm._v("\n                            The Retirement Date must be after " + _vm._s(_vm.earliestRetirementDate) + "\n                        ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.retirementAtOnsetRules
    }
  }, [_vm._v("\n                            The Retirement Date must be after the onset of symptoms " + _vm._s(_vm.getClaimantValue('onsetOfSymptoms')) + "\n                        ")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Past Loss of Earnings\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Is there any past loss of earnings?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "past_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pastLossOfEarnings),
      expression: "pastLossOfEarnings"
    }],
    attrs: {
      "id": "past_loss_of_earnings"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pastLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateLossOfEarnings('past')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.pastLossOfEarnings) ? _c('income', {
    attrs: {
      "name": "Claimant",
      "retired": true,
      "income": _vm.claimant.income,
      "lossOfEarnings": _vm.pastLossOfEarnings,
      "start-disabled": false,
      "type": "past"
    },
    on: {
      "action": _vm.updateIncome
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                Future Loss of Earnings & Pension\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                        Is there any future loss of earnings and / or pension?\n                    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_loss_of_earnings",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfEarnings),
      expression: "futureLossOfEarnings"
    }],
    attrs: {
      "id": "future_loss_of_earnings"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfEarnings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateLossOfEarnings('future')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futureLossOfEarnings) ? _c('income', {
    attrs: {
      "name": "Claimant",
      "retired": _vm.retired,
      "income": _vm.claimant.income,
      "lossOfEarnings": _vm.futureLossOfEarnings,
      "type": "future"
    },
    on: {
      "action": _vm.updateIncome
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "warning_text_lost_years",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("The discount figures")]), _vm._v(" "), _c('p', [_vm._v("Do you wish to discount the future loss of earnings multiplier for contingencies other than mortality? For example, to reflect the risks and vicissitudes of life, such as periods not earning from ill-health or loss of employment or taking care for dependents. If so then Tables A-D of the Ogden Tables provide framework figures for discounting the multiplier to reflect these risks. Please note the discount figures only apply up to age "), _c('strong', [_vm._v("54")]), _vm._v(". Thereafter the tables state:")]), _vm._v(" "), _c('blockquote', [_c('i', [_vm._v("‘For older ages the reduction factors increase towards 1 at retirement age for those who are employed and fall towards 0 for those who are not employed. However, where the claimant is older than "), _c('strong', [_vm._v("54")]), _vm._v(", it is anticipated that the likely future course if employment status will be particularly dependent on individual circumstances, so that the use of factors based on averages would not be appropriate. Hence reduction factors are not provided for older ages’.")])]), _vm._v(" "), _c('p', [_vm._v("ABCQuantum does however provide discount factors beyond age "), _c('strong', [_vm._v("54")]), _vm._v(" to retirement age by simple interpolation. So for an employed male aged "), _c('strong', [_vm._v("54")]), _vm._v(", not disabled with A level qualifications the discount factor in "), _c('strong', [_vm._v("Table A is 0.79")]), _vm._v(". The figure at retirement age of say "), _c('strong', [_vm._v("65/66 is 1.0")]), _vm._v(". For ages between "), _c('strong', [_vm._v("54–65/66")]), _vm._v(" we interpolate between the figures "), _c('strong', [_vm._v("0.79–1.0")]), _vm._v(".")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'income_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0855c801!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/IncomeInformation.vue
// module id = 1564
// module chunks = 0